// extracted by mini-css-extract-plugin
export default {"notificationsWrapper":"NotificationsPage_notificationsWrapper__LxF7u"};